module.exports = __webpack_public_path__ + "static/media/overpass-semibold.ca834120.woff2";